<template>
  <ImageMedia filename="refresh.png" />
</template>
